export const USER_GROUP_NAME = {
  DEVELOPER: 'Developers'
};

export const hasUserInGroup = (globalUserInfo, groupName) => {
  const userGroupNames = globalUserInfo?.['cognito:groups'] || [];

  return userGroupNames.includes(groupName);
};
